import { useLingui } from "@lingui/react";
import FieldValuePair from "../FieldValuePair.tsx";
import type { SpecProps } from "./types.ts";

export const Model = ({ model }: SpecProps<"model">) => {
  const { i18n } = useLingui();

  if (model == null) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.common.model",
    message: "Model",
    comment: "Field for 'model' in ad specification",
  });
  return <FieldValuePair field={field} value={model} />;
};
